import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { familiarItems, questions } from '../data/content';
export function FamiliarSection() {
  return <section className="bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-75" data-mp="1d8hwej7zw4mm">
      <div className="mx-auto w-full max-w-4xl" data-id="element-76" data-mp="1d5m00zbspo0a">
        <h2 className="text-center text-[24px] font-black leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-77" data-mp="189y9oglkuot7">
          Does this sound familiar?
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[14.5px] leading-relaxed text-navy2 sm:text-lg" data-id="element-78" data-mp="ghph3nsvyglw">
          If you answer <strong className="font-extrabold text-navy" data-id="element-79" data-mp="u9dqvkfnwszp">yes</strong>{' '}
          to any of these, ALIGNER TREATMENT BLUEPRINT™ was created for you.
        </p>

        <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-80" data-mp="pgkm4wk71knm">
          {familiarItems.map(item => <li key={item.text} className="flex gap-3.5 rounded-2xl border border-navy/10 bg-white p-4 shadow-sm sm:p-5" data-id="element-81" data-mp="1qgk2tmnlsyq">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-skysoft text-xl" aria-hidden="true" data-id="element-82" data-mp="1hlacx0r1x5d2">
                {item.emoji}
              </span>
              <p className="text-[13.5px] leading-snug text-navy2 sm:text-[15px]" data-id="element-83" data-mp="1re94mrhuhc0w">
                {item.text}
              </p>
            </li>)}
        </ul>

        <div className="mt-12 rounded-3xl border border-navy/10 bg-white p-5 shadow-sm sm:p-9" data-id="element-84" data-mp="yosfc2piub8w">
          <h3 className="text-center text-[21px] font-black leading-tight text-navy sm:text-3xl" data-id="element-85" data-mp="13muavn44w319">
            The problem isn’t a lack of knowledge.
            <span className="mt-1.5 block text-cta" data-id="element-86" data-mp="1cmqtb6zxk5nv">
              It’s the lack of a structured way to organize it.
            </span>
          </h3>

          <p className="mt-5 text-center text-[14.5px] text-navy2 sm:text-base" data-id="element-87" data-mp="2k00x1d5ls2wv">
            You don’t need another 300-page textbook. You need to know:
          </p>

          <ul className="mt-6 space-y-2.5" data-id="element-88" data-mp="owmgdle9h7ca">
            {questions.map(question => <li key={question} className="flex items-center gap-3 rounded-xl bg-skysoft px-3.5 py-3" data-id="element-89" data-mp="jyubzrwfjsr7">
                <ArrowRightIcon className="h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-90" data-mp="xxas29g6mvm0" />
                <span className="text-[13.5px] font-semibold text-navy sm:text-[15px]" data-id="element-91" data-mp="5a806060hj4q">
                  {question}
                </span>
              </li>)}
          </ul>

          <p className="mt-6 text-center text-[14px] font-semibold text-navy2 sm:text-base" data-id="element-92" data-mp="f09moniputhj">
            That’s what ALIGNER TREATMENT BLUEPRINT™ is designed to help you
            structure.
          </p>

          <div className="mx-auto mt-8 max-w-md" data-id="element-93" data-mp="3in08gqwjapgt">
            <CtaButton label="I want a structured aligner workflow" subLabel="One-time payment of $27 · Automatic currency conversion" data-id="element-94" data-mp="3dp8612y9jkyd" />
          </div>
        </div>
      </div>
    </section>;
}